export default {
  GOOD: [0, 2366], //start and track lenghth
  PERFECT: [2587, 2366],
  FAIL: [4973, 2366],
  LEVEL_COMPLETE: [7437, 2366],
  GAME_COMPLETE: [10068, 2366],
  GAME_OVER: [12444, 2366]
}
